export const slug = "client-portal";
export const title = "Client Portal";
export const section = "Core";
export const content = `
# Client Portal

The Client Portal is the self-service area for clients. It is separate from the staff application and is designed to be simple enough for anyone to use on a phone.

## What the Portal Is

The portal lets clients:

- View and update their contact information and household members.
- Submit changes for staff approval.
- Check in to the Saturday queue from their phone.
- See their Sharing Tree pickup window.

## How Clients Log In (Passwordless)

Clients do not create passwords. Instead:

1. They enter their phone number or email on the portal login page.
2. The system sends a **one-time magic link** to their phone or inbox.
3. Clicking the link logs them in instantly — no password needed.

The magic link expires after 15 minutes. If it expires, they can request a new one.

## Submitting Address & Household Changes

From the portal home screen, a client can tap **Update My Info** to:

- Edit their address or contact details.
- Add or remove household members.

Changes go into a **pending approval** queue and do not take effect until a staff member reviews them. Clients see a "Pending Review" badge until the change is approved or rejected.

## Sharing Tree Signup

If your food bank has opened Sharing Tree enrollment, clients may see a **Sign Up for Sharing Tree** option in the portal. They can submit their household size and preferred pickup window. Staff review and confirm the enrollment.

## Pickup Window Display

Once enrolled in Sharing Tree, the client's portal home screen shows their assigned pickup window — date, time, and location.

## Tips for Staff

- If a client says they did not receive their magic link, check that their phone/email is correct in their record and that no bounce flag is set.
- The portal URL is separate from the staff application. Share only the portal URL with clients.
`;
